module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "new-group-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg modal-xlg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "titleized"
  }, [_vm._v(_vm._s(_vm.$t('groups.actions.create.title')))]), _vm._m(0)]), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadContacts),
      expression: "loadContacts"
    }],
    staticClass: "modal-body",
    attrs: {
      "infinite-scroll-distance": "10"
    }
  }, [_c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "col-md-8 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('groups.attributes.groupName')))]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.group_name),
      expression: "group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.group_name = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "number-with-label"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.contacts_count))]), _c('div', {
    staticClass: "labels"
  }, [_c('div', {
    staticClass: "upper-label"
  }, [_vm._v(_vm._s(_vm.$t('groups.label.contacts')))]), _c('div', {
    staticClass: "lower-label"
  }, [_vm._v(_vm._s(_vm.$t('groups.label.added')))])]), _c('div', {
    staticClass: "clear"
  })])])]), _c('contact-list', {
    attrs: {
      "contacts": _vm.loaded_contacts,
      "view_mode": _vm.contactListViewModes().group_picker,
      "initially_selected_contact_ids": _vm.persisted_selected_contact_ids
    },
    on: {
      "filter": _vm.filter,
      "contact-selected": _vm.updateSelectedContacts
    }
  }), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.next_page),
      expression: "!next_page"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v(_vm._s(_vm.$t('groups.feedback.noMoreResults')))])], 1)], 1), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "btn btn-gray",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('div', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "select-contacts",
      "disabled": !_vm.group_name
    },
    on: {
      "click": _vm.createGroup
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.conclude')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c16c2e20!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contact_groups/new.vue
// module id = 1210
// module chunks = 1